import { render, staticRenderFns } from "./dragDropEditor.vue?vue&type=template&id=88b9afbe&"
import script from "./dragDropEditor.vue?vue&type=script&lang=js&"
export * from "./dragDropEditor.vue?vue&type=script&lang=js&"
import style0 from "./dragDropEditor.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports